module.exports = __webpack_public_path__ + "static/media/banner-wide.eedb3404.svg";